import React from 'react'
import UsersSessionRightTable from '../../components/users-session-right-table/UsersSessionRightTable'

function UserSessionRight() {
  return (
    <UsersSessionRightTable/>
  )
}

export default UserSessionRight